
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	computed: {},
	methods: {},
	async created() {
		this.state.fetchThreads();
	},
	async mounted() {

	},
	beforeDestroy(): void {

	},
	components: {

	}
});
